import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-bici-asistencias',
  templateUrl: './bici-asistencias.component.html',
  styles: []
})
export class BiciAsistenciasComponent implements OnInit {
  
  @Input()
  coberturas: boolean = true;
  @Input()
  asistencias: boolean = true;
  @Input()
  cotizar: boolean = true;
  @Input()
  step: number = 1;
  @Output()
  cotizarClick: EventEmitter<any>;

  constructor() {
    this.cotizarClick = new EventEmitter();
   }

  ngOnInit() {
  }

  goTo(el: string = "") {
      this.cotizarClick.emit();
      setTimeout(() => {

        $('html, body').animate({
          scrollTop: $("#" + el).offset().top
        }, 1000);

      }, 200);

  }

}
